import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomerCenterService } from "../../../services";
import TopSetion from '../../../components/customer-service-center/TopSetion';
import SubHeading from '../../../components/customer-service-center/SubHeading';
import searchIcon from '../../../assets/img/customer-service-center/search-file.png';
import { validateContactWritingForm } from '../../../utils/validation/ContactWritingValidation';
import { getFileName, processAttachments } from '../../../utils/fileNameUtils';

const MASKED_PASSWORD = '******';

const ContactUsWriting = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        "writerName": "",
        "title": "",
        "boardContent": "",
        "secretFlag": "Y",
        "password": "",
        "email": "",
        "files": []
    });
    const [attachedFiles, setAttachedFiles] = useState([]);
    const [fileInputRef, setFileInputRef] = useState(null);
    const [errors, setErrors] = useState({});
    const { id } = useParams();
    const [existingUploadIds, setExistingUploadIds] = useState([]);
    const [showPasswordMask, setShowPasswordMask] = useState(false);
    const [hasPasswordChanged, setHasPasswordChanged] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === 'password') {
            setHasPasswordChanged(true);
            setShowPasswordMask(false);
        }
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        setAttachedFiles(prev => [...(prev || []), ...files]);
        setFormData(prev => ({
            ...prev,
            files: [...(prev.files || []), ...files]
        }));
    };

    const removeFile = (index) => {
        setAttachedFiles(prev => (prev || []).filter((_, i) => i !== index));
        setFormData(prev => ({
            ...prev,
            files: (prev.files || []).filter((_, i) => i !== index)
        }));

        if (existingUploadIds.length > 0) {
            const uploadIds = existingUploadIds.filter((_, i) => i !== index);
            setExistingUploadIds(uploadIds);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form before submission
        const errors = validateContactWritingForm(formData, { isEditMode: Boolean(id) });
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            return;
        }

        // Create FormData for multipart/form-data submission
        const formDataToSend = new FormData();

        // Add text fields
        formDataToSend.append('writerName', formData.writerName);
        formDataToSend.append('title', formData.title);
        formDataToSend.append('boardContent', formData.boardContent);
        formDataToSend.append('secretFlag', formData.secretFlag);
        if (!id || hasPasswordChanged) {
            formDataToSend.append('password', formData.password);
        }
        formDataToSend.append('email', formData.email);

        // Add files
        (formData.files || []).forEach((file, index) => {
            formDataToSend.append('files', file);
        });

        console.log('FormData being sent:', formDataToSend);

        if (id) {
            formDataToSend.append('existingUploadIds', existingUploadIds);
            try {
                const response = await CustomerCenterService.updateInquiryById(id, formDataToSend);
                navigate('/contact-us');
            } catch (error) {
                console.log(error);
            }
        } else {
            try {
                const response = await CustomerCenterService.postInquiry(formDataToSend);
                navigate('/contact-us');
            } catch (error) {
                console.log(error);
            }
        }
    };

    const handleCancel = () => {
        navigate('/contact-us');
    };

    useEffect(() => {
        if (id) {
            fetchInquiryData();
        }
    }, [id]);


    const fetchInquiryData = async () => {
        try {
            const response = await CustomerCenterService.getInquiryDeatilsById(id);
            setFormData({
                writerName: response.writerName || "",
                title: response.title || "",
                boardContent: response.content || "",
                secretFlag: response.secretFlag || "Y",
                password: "",
                email: response.email || "",
                files: [] // Ensure files array is always initialized
            });
            setShowPasswordMask(true);
            setHasPasswordChanged(false);

            const existingUploadIds = response.attachments.map(attachment => attachment.uploadId);
            setExistingUploadIds(existingUploadIds);
            const ExistFiles = response.attachments.map(attachment => attachment.uploadUrl);

            // Process attachments using utility function
            const processedAttachments = processAttachments(ExistFiles);
            setAttachedFiles(processedAttachments);
        } catch (error) {
            console.log(error);
        }
    };

    const handlePasswordFocus = () => {
        if (id && showPasswordMask) {
            setShowPasswordMask(false);
        }
    };

    const handlePasswordBlur = () => {
        if (id && !hasPasswordChanged && !formData.password) {
            setShowPasswordMask(true);
        }
    };

    return (
        <>
            <div className="announcement-list-page">
                <TopSetion />

                {/* Main Content */}
                <main className="main-content">
                    <SubHeading heading="문의하기" />

                    <section className="contact-us-writing-section">
                        <div className="contact-us-writing-inner">
                            <form className="contact-form" onSubmit={handleSubmit}>
                                {/* Form Fields */}
                                <div className="form-fields">
                                    {/* Name and Email Row */}
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label htmlFor="name" className="form-label required">
                                                이름
                                            </label>
                                            <div className="input-wrapper">
                                                <input
                                                    type="text"
                                                    id="name"
                                                    name="writerName"
                                                    className={`form-input ${errors.writerName ? 'error' : ''}`}
                                                    placeholder="이름을 입력해주세요"
                                                    value={formData.writerName}
                                                    onChange={handleInputChange}
                                                />
                                                {errors.writerName && (
                                                    <div className="input-error-message">{errors.writerName}</div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="email" className="form-label required">
                                                이메일
                                            </label>
                                            <div className="input-wrapper">
                                                <input
                                                    type="email"
                                                    id="email"
                                                    name="email"
                                                    className={`form-input ${errors.email ? 'error' : ''}`}
                                                    placeholder="이메일을 입력해주세요"
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                />
                                                {errors.email && (
                                                    <div className="input-error-message">{errors.email}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Password */}
                                    <div className="form-row password-row">
                                        <div className="form-group">
                                            <label htmlFor="password" className="form-label required">
                                                비밀번호
                                            </label>
                                            <div className="input-wrapper">
                                                <input
                                                    type="password"
                                                    id="password"
                                                    name="password"
                                                    className={`form-input ${errors.password ? 'error' : ''}`}
                                                    placeholder="비밀번호를 입력해주세요"
                                                    value={showPasswordMask ? MASKED_PASSWORD : formData.password}
                                                    onChange={handleInputChange}
                                                    onFocus={handlePasswordFocus}
                                                    onBlur={handlePasswordBlur}
                                                    autoComplete='new-password'
                                                    maxLength={10}
                                                />
                                                {errors.password && (
                                                    <div className="input-error-message">{errors.password}</div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="form-group password-hint-group">
                                            <span className="password-hint">영문+숫자 10자리 미만</span>
                                        </div>
                                    </div>

                                    {/* Title */}
                                    <div className="form-group">
                                        <label htmlFor="title" className="form-label required">
                                            제목
                                        </label>
                                        <div className="input-wrapper">
                                            <input
                                                type="text"
                                                id="title"
                                                name="title"
                                                className={`form-input ${errors.title ? 'error' : ''}`}
                                                placeholder="제목을 입력해주세요"
                                                value={formData.title}
                                                onChange={handleInputChange}
                                            />
                                            {errors.title && (
                                                <div className="input-error-message">{errors.title}</div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div className="form-group">
                                        <label htmlFor="boardContent" className="form-label required">
                                            내용
                                        </label>
                                        <div className="input-wrapper">
                                            <textarea
                                                id="boardContent"
                                                name="boardContent"
                                                className={`form-textarea ${errors.content ? 'error' : ''}`}
                                                placeholder="내용을 입력해주세요."
                                                rows="6"
                                                value={formData.boardContent}
                                                onChange={handleInputChange}
                                            ></textarea>
                                            {errors.content && (
                                                <div className="input-error-message">{errors.content}</div>
                                            )}
                                        </div>
                                    </div>

                                    {/* File Attachment - Updated Design */}
                                    <div className="form-group no-border-bottom">
                                        <label htmlFor="file" className="form-label">
                                            첨부파일
                                        </label>

                                        <div className="file-attachment-container">
                                            <div className="file-input-container">
                                                <input
                                                    type="file"
                                                    id="file"
                                                    name="file"
                                                    className="form-file-input"
                                                    multiple
                                                    onChange={handleFileChange}
                                                    ref={setFileInputRef}
                                                />

                                                {/* Search Input Field */}
                                                <div className="search-input-wrapper" onClick={() => fileInputRef?.click()}>
                                                    <input
                                                        type="text"
                                                        className="search-input-inner"
                                                        placeholder="Search"
                                                        readOnly
                                                    />
                                                    <div className="search-separator"></div>
                                                    <button
                                                        type="button"
                                                        className="search-browse-btn"
                                                    >
                                                        <img src={searchIcon} alt="Search" className="search-icon" />
                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                    {attachedFiles.length > 0 && (
                                        <div className="form-group">
                                            <label htmlFor="file" className="form-label mobile-view">&nbsp;</label>
                                            <div className="attached-files">
                                                {attachedFiles.map((file, index) => (
                                                    <div key={`${getFileName(file)}-${index}`} className="attached-file">
                                                        <span className="file-name">{getFileName(file)}</span>
                                                        <button
                                                            type="button"
                                                            className="remove-file-btn"
                                                            onClick={() => removeFile(index)}
                                                        >
                                                            ×
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Form Actions */}
                                <div className="form-actions">
                                    <button type="button" className="search-button" onClick={handleCancel}>
                                        취소
                                    </button>
                                    <button type="submit" className="search-button green-button" >
                                        등록
                                    </button>
                                </div>
                            </form>
                        </div>
                    </section>
                </main>
            </div>
        </>
    );
};

export default ContactUsWriting;